module.exports = __webpack_public_path__ + "img/slider-66.880f1f4b.jpg";